import { cellTypes, dataFormatTypes } from "@bento-core/table";
import gql from "graphql-tag";
import downloadSuccess from "../assets/dash/downloadSuccess.svg";
import downloadLock from "../assets/dash/downloadLock.svg";

// --------------- Tooltip configuration --------------
export const tooltipContent = {
  src: "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/icdc/images/svgs/Tooltip.SpeechBubble.svg",
  alt: "tooltipIcon",
};

export const title = {
  studyFile: "",
  armsAndCohort: "",
};

export const headerIcon =
  "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/ctdc/images/svg/Icon-TrialDetail.svg";
export const externalIcon =
  "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/ctdc/images/svg/ExternalLinkIcon.svg";

export const tab = {
  items: [
    {
      index: 0,
      label: "Overview",
      value: "overview",
    },
    {
      index: 1,
      label: "Clinical Data",
      value: "clinical_data",
    },
    {
      index: 2,
      label: "Study Files",
      value: "study_files",
    },
    {
      index: 3,
      label: "Publications",
      value: "publications",
    },
  ],
};

export const STUDY_FILES_BUTTON_TOOLTIP = "Add selected file(s) to cart";

// Tooltip configuration for Study Files wrapper buttons
export const studyFilesTooltipContent = {
  icon: "https://raw.githubusercontent.com/google/material-design-icons/master/src/action/help/materialicons/24px.svg",
  alt: "tooltipIcon",
  arrow: false,
  classes: "customTooltip",
  Study_Files: STUDY_FILES_BUTTON_TOOLTIP,
};

// --------------- GraphQL Queries for Study Files Tab ---------------

// Separate query for Study Files Tab with pagination support
// Uses fileOverview with association filter set to 'study'
export const GET_STUDY_FILES_QUERY = gql`
  query fileOverview(
    $study_id: [String]
    $study_short_name: [String]
    $association: [String]
    $data_file_type: [String]
    $data_file_format: [String]
    $data_file_uuid: [String]
    $study_accession: [String]
    $first: Int
    $offset: Int = 0
    $order_by: String = "data_file_uuid"
    $sort_direction: String = "asc"
  ) {
    fileOverview(
      study_short_name: $study_short_name
      study_id: $study_id
      study_accession: $study_accession
      association: $association
      data_file_type: $data_file_type
      data_file_format: $data_file_format
      data_file_uuid: $data_file_uuid
      first: $first
      offset: $offset
      order_by: $order_by
      sort_direction: $sort_direction
    ) {
      data_file_name
      data_file_type
      data_file_description
      data_file_format
      data_file_size
      data_file_uuid
      study_accession
    }
  }
`;

// Query for adding selected study files to cart
// Uses fileOverview with association filter set to 'study'
export const GET_FILE_IDS_FOR_SELECTED_STUDY_FILES = gql`
  query fileAddSelectedToCart(
    $data_file_uuid: [String]
    $study_id: [String]
    $study_short_name: [String]
    $association: [String]
    $data_file_type: [String]
    $data_file_format: [String]
    $study_accession: [String]
    $first: Int
    $offset: Int = 0
    $order_by: String = "data_file_uuid"
    $sort_direction: String = "asc"
  ) {
    fileOverview(
      data_file_uuid: $data_file_uuid
      study_id: $study_id
      study_short_name: $study_short_name
      study_accession: $study_accession
      association: $association
      data_file_type: $data_file_type
      data_file_format: $data_file_format
      first: $first
      offset: $offset
      order_by: $order_by
      sort_direction: $sort_direction
    ) {
      data_file_uuid
    }
  }
`;

// Study Detail: Study Files Tab table configuration
export const studyFilesTableConfig = {
  name: "Study_Files",
  dataKey: "data_file_uuid",
  buttonText: "Add Selected Files",
  addFilesRequestVariableKey: "data_file_uuid",
  addFilesResponseKeys: ["fileOverview", "data_file_uuid"],
  addSelectedFilesQuery: GET_FILE_IDS_FOR_SELECTED_STUDY_FILES,
  tableMsg: {
    noMatch: "No study-level files associated with this study.",
  },
  selectableRows: true,
  defaultSortField: "data_file_name",
  defaultSortDirection: "asc",
  extendedViewConfig: {
    pagination: true,
    manageViewColumns: { title: "View Columns" },
    download: {
      downloadCsv: "Download Table Contents As CSV",
      downloadFileName: "CTDC_Study_Files",
    },
  },
  columns: [
    {
      cellType: cellTypes.CHECKBOX,
      role: cellTypes.CHECKBOX,
      display: true,
      tooltipText: "",
    },
    {
      dataField: "data_file_name",
      header: "File Name",
      display: true,
    },
    {
      dataField: "data_file_type",
      header: "File Type",
      display: true,
      role: cellTypes.DISPLAY,
    },
    {
      dataField: "data_file_description",
      header: "Description",
      display: true,
      role: cellTypes.DISPLAY,
      tooltipText: "Sort",
    },
    {
      dataField: "data_file_format",
      header: "Format",
      display: true,
      role: cellTypes.DISPLAY,
      tooltipText: "Sort",
    },
    {
      dataField: "data_file_size",
      header: "Size",
      display: true,
      role: cellTypes.DISPLAY,
      dataFormatType: dataFormatTypes.FORMAT_BYTES,
      cellType: cellTypes.FORMAT_DATA,
      tooltipText: "Sort",
    },
    {
      dataField: "data_file_uuid",
      header: "Access",
      display: true,
      cellType: cellTypes.CUSTOM_ELEM,
      downloadDocument: true,
      documentDownloadProps: {
        fileSizeColumn: "data_file_size",
        fileLocationColumn: "data_file_uuid",
        fileFormatColumn: "data_file_format",
        fileName: "data_file_name",
        studyAccessionColumn: "study_accession",
        toolTipTextFileDownload: "Click to download a copy of this file if you have been approved by dbGaP",
        iconFileDownload: downloadSuccess,
        iconUnauthenticated: downloadLock,
        toolTipTextUnauthenticated:
          "You must be logged in and must have already been granted access to download a copy of this file",
      },
      role: cellTypes.DISPLAY,
      tooltipText: "Sort",
    },
  ],
};

export const biospecimenProfile = {
  tabs: [
    {
      index: 0,
      label: "TIMEPOINT",
      value: "specimen_timepoints",
    },
    {
      index: 1,
      label: "BIOSPECIMENS",
      value: "specimen_types",
    },
  ],
};

export const palette = [
  "#0A8B8B",
  "#6AC6B6",
  "#C33B27",
  "#FDB915",
  "#381F5F",
  "#007EA5",
  "#8B5996",
  "#0A8B8B",
  "#6AC6B6",
  "#C33B27",
  "#FDB915",
  "#381F5F",
  "#007EA5",
];

/* * Xaxis config value */
export const argumentConfiguration = {
  field: "group",
  visible: false,
  position: "inside",
  size: 12,
  title: {
    text: "Biospecimens",
    margin: 15,
    alignment: "center",

    size: 12,
    color: "#444444",
    weight: 400,
    family: "Roboto",
  },
  label: {
    size: 20,
    position: "outside",
    staggeringSpacing: 19,
  },
};

/* * Xaxis config value */
export const timePointArgumentConfiguration = {
  ...argumentConfiguration,
  title: {
    ...argumentConfiguration.title,
    text: "Collection Timepoint",
  },
};

/* * Yaxis config value */
export const valueConfiguration = {
  field: "count",
  size: 12,
  allowDecimals: false,
  title: {
    text: "Biospecimen Count",
    size: 12,
    color: "#444444",
    weight: 400,
    family: "Roboto",
  },
  chartGrid: {
    visible: true,
  },
  label: {
    size: 12,
    position: "outside",
  },
  tick: {
    visible: true,
  },
};

/** common series setting */
export const seriesSetting = {
  maxBarWidth: 200,
};

export const tooltipConfig = {
  enable: true,
  family: "Open Sans",
  size: 13,
  color: "#929292", // border Color
  width: 1,
  blur: 4,
  offsetX: 0,
  offsetY: 4,
  opacity: 0.25,
  shadowColor: "#000000",
  arrowLength: 10,
  paddingTopBottom: 10,
  interactive: false,
};

export const studyClinicalDataQuery = gql`
  query clinicalDataTab($study_id: [String]) {
    clinicalData(study_id: $study_id) {
      study_short_name
      unique_node_types

      # Clinical: diagnosis
      diagnosisParticipantCount
      diagnosisNodeCount
      diagnosisNodeData {
        participant_ids
        ctep_disease_term
        date_of_diagnosis
        date_of_diagnosis_original
        date_of_diagnosis_unit
        diagnosis_record_id
        histological_subtype
        histology
        meddra_disease_code
        primary_diagnosis_disease_group
        primary_disease_site
        snomed_disease_code
        snomed_disease_term
      }

      # Clinical: participant_status
      participantStatusNodeCount
      participantStatusParticipantCount
      participantStatusNodeData {
        participant_ids
        off_study
        off_study_reason
        participant_status_record_id
        survival_status
      }
    }
    clinicalTrialData(study_id: $study_id) {
      study_short_name

      # Clinical Trial: targeted_therapy
      targetedTherapyParticipantCount
      targetedTherapyNodeCount
      targetedTherapyNodeData {
        participant_ids
        targeted_therapy
        targeted_therapy_dose
        targeted_therapy_frequency
        targeted_therapy_record_id
      }

      # Clinical Trial:non_targeted_therapy
      nonTargetedTherapyParticipantCount
      nonTargetedTherapyNodeCount
      nonTargetedTherapyNodeData {
        participant_ids
        non_targeted_therapy_record_id
        best_response_to_non_targeted_therapy
        non_targeted_therapy
        non_targeted_therapy_dose
        non_targeted_therapy_frequency
      }

      # Clinical Trial: surgery
      surgeryParticipantCount
      surgeryNodeCount
      surgeryNodeData {
        participant_ids
        surgical_procedure_record_id
        extent_of_residual_disease
        surgical_procedure
        surgical_procedure_anatomical_location
        surgical_procedure_date
        surgical_procedure_findings
        surgical_procedure_therapeutic
      }

      # Clinical Trial: radiotherapy
      radiotherapyParticipantCount
      radiotherapyNodeCount
      radiotherapyNodeData {
        participant_ids
        radiation_dose
        radiation_extent
        radiation_frequency
        radiological_procedure
        radiological_procedure_anatomical_location
        radiological_procedure_record_id
      }
      __typename
    }
  }
`;

export const GET_STUDY_DETAIL_DATA_QUERY = gql`
  query studyDetailPageQueries($study_id: [String]) {
    # Clinical Data Tab: Node Counts
    clinicalDataNodeCounts: clinicalData(study_id: $study_id) {
      diagnosis: diagnosisNodeCount
      participant_status: participantStatusNodeCount
    }
    clinicalTrialDataNodeCounts: clinicalTrialData(study_id: $study_id) {
      targeted_therapy: targetedTherapyNodeCount
      non_targeted_therapy: nonTargetedTherapyNodeCount
      surgery: surgeryNodeCount
      radiotherapy: radiotherapyNodeCount
    }

    # Clinical Data Tab: Participant Counts
    clinicalDataParticipantCounts: clinicalData(study_id: $study_id) {
      diagnosis: diagnosisParticipantCount
      participant_status: participantStatusParticipantCount
    }
    clinicalTrialDataParticipantCounts: clinicalTrialData(study_id: $study_id) {
      targeted_therapy: targetedTherapyParticipantCount
      non_targeted_therapy: nonTargetedTherapyParticipantCount
      surgery: surgeryParticipantCount
      radiotherapy: radiotherapyParticipantCount
    }

    studyByStudyShortName(study_id: $study_id) {
      study_id
      study_name
      study_short_name
      study_description
      study_type
      study_accession
      dates_of_conduct
      participant_count
      associated_links {
        associated_link_name
        associated_link_url
        associated_link_record_id
      }
      image_collection {
        image_collection_name
        repository_name
        image_collection_url
        image_type_included
        collection_access
      }
    }

    studyDiagnosisByStudyShortName(study_id: $study_id) {
      ctep_disease_terms
    }

    StudyDataFileByStudyShortName(study_id: $study_id) {
      list_type
    }

    StudySpecimenByStudyShortName(study_id: $study_id) {
      specimen_types {
        group
        count
      }
      specimen_timepoints {
        group
        count
      }
      specimen_count
    }

    studyZipFileQuery(study_id: $study_id) {
      study_short_name
      study_id
      data_file_type
      zip_files {
        data_file_uuid
        data_file_name
        data_file_type
        data_file_description
        data_file_format
        data_file_size
        data_file_checksum_value
        data_file_checksum_type
        data_file_compression_status
        data_file_location
      }
    }
  }
`;

/**
 * Helper function to create node metadata manifest
 * Creates an object with both keysToInclude and header set to the same keys
 * @param {string[]} keys - Array of field names to include in the manifest
 * @returns {Object} Manifest object with keysToInclude and header
 */
const makeManifest = (keys) => ({
  keysToInclude: keys,
  header: keys,
});

export const diagnosisNodeMetadata = makeManifest([
  "participant_ids",
  "ctep_disease_term",
  "date_of_diagnosis",
  "date_of_diagnosis_original",
  "date_of_diagnosis_unit",
  "diagnosis_record_id",
  "histological_subtype",
  "histology",
  "meddra_disease_code",
  "primary_diagnosis_disease_group",
  "primary_disease_site",
  "snomed_disease_code",
  "snomed_disease_term",
]);

export const participantStatusNodeMetadata = makeManifest([
  "participant_ids",
  "off_study",
  "off_study_reason",
  "participant_id",
  "participant_status_record_id",
  "survival_status",
]);

export const targetedTherapyNodeMetadata = makeManifest([
  "participant_ids",
  "targeted_therapy",
  "targeted_therapy_dose",
  "targeted_therapy_frequency",
  "targeted_therapy_record_id",
]);

export const nonTargetedTherapyNodeMetadata = makeManifest([
  "participant_ids",
  "non_targeted_therapy_record_id",
  "best_response_to_non_targeted_therapy",
  "non_targeted_therapy",
  "non_targeted_therapy_dose",
  "non_targeted_therapy_frequency",
]);

export const surgeryNodeMetadata = makeManifest([
  "participant_ids",
  "surgical_procedure_record_id",
  "extent_of_residual_disease",
  "surgical_procedure",
  "surgical_procedure_anatomical_location",
  "surgical_procedure_date",
  "surgical_procedure_findings",
  "surgical_procedure_therapeutic",
]);

export const radiotherapyNodeMetadata = makeManifest([
  "participant_ids",
  "radiation_dose",
  "radiation_extent",
  "radiation_frequency",
  "radiological_procedure",
  "radiological_procedure_anatomical_location",
  "radiological_procedure_record_id",
]);

export const table = {
  title: "Clinical and Translational Data Commons",
  defaultSortField: "clinicalDataNode",
  // 'asc' or 'desc'
  defaultSortDirection: "asc",
  columns: [
    {
      dataField: "clinicalDataNode",
      header: "Clinical Data Nodes",
      sort: "asc",
      display: true,
      cellType: cellTypes.CUSTOM_ELEM,
      tooltipText: "sort",
    },
    {
      dataField: "clinicalDataDescription",
      header: "Definition",
      sort: "asc",
      display: true,
      cellType: cellTypes.CUSTOM_ELEM,
      tooltipText: "sort",
    },
    {
      dataField: "participantCount",
      header: "Participants",
      sort: "asc",
      display: true,
      cellType: cellTypes.CUSTOM_ELEM,
      tooltipText:
        "For each of the nodes listed below, the number of participants represented by one or more records within that node",
    },
    {
      dataField: "recordCount",
      header: "Records",
      sort: "asc",
      display: true,
      cellType: cellTypes.CUSTOM_ELEM,
      tooltipText:
        "For each of the nodes listed below, the total number of records within each node. Participants may have multiple/numerous records within certain nodes",
    },
    {
      dataField: "csvDataRow",
      header: "CSV",
      display: true,
      cellType: cellTypes.CUSTOM_ELEM,
    },
  ],
  rows: [
    {
      title: "Diagnosis",
      countKey: "diagnosis",
      csvDownload: "diagnosisNodeData",
      manifest: diagnosisNodeMetadata,
    },
    {
      title: "Participant Status",
      countKey: "participant_status",
      csvDownload: "participantStatusNodeData",
      manifest: participantStatusNodeMetadata,
    },
    {
      title: "Targeted Therapy",
      countKey: "targeted_therapy",
      csvDownload: "targetedTherapyNodeData",
      manifest: targetedTherapyNodeMetadata,
    },
    {
      title: "Non Targeted Therapy",
      countKey: "non_targeted_therapy",
      csvDownload: "nonTargetedTherapyNodeData",
      manifest: nonTargetedTherapyNodeMetadata,
    },
    {
      title: "Surgery",
      countKey: "surgery",
      csvDownload: "surgeryNodeData",
      manifest: surgeryNodeMetadata,
    },
    {
      title: "Radiotherapy",
      countKey: "radiotherapy",
      csvDownload: "radiotherapyNodeData",
      manifest: radiotherapyNodeMetadata,
    },
  ],
  tableMsg: {
    noMatch: "Data unavailable at this time",
  },
};

export const tableLayOut = [
  {
    container: "paginatedTable",
    paginatedTable: true,
  },
];

// --------------- Publications Tab Configuration ---------------
export const GET_STUDY_PUBLICATIONS_QUERY = gql`
  query studyPublications($study_id: [String]) {
    publicationInfo(study_id: $study_id) {
      publication_title
      authorship
      year_of_publication
      journal_citation
      digital_object_id
      pubmed_id
    }
  }
`;

export const publicationsTableConfig = {
  name: "Publications",
  tableMsg: {
    noMatch: "There are no publications available for this study.",
  },
};
